import { ASSET_PREFIX } from 'utils/constants'
import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import ProgressBar from 'components/raffle/ProgressBar'

const OverviewSection = ({ ctaHandler, ticketCount, ticketCap, showProgressBar, drawDate }) => (
  <div className="container">
    <img
      className="image"
      src={`${ASSET_PREFIX}/images/iceland-raffle/lift.jpg`}
      alt="Lifting lowering down into volcano"
    />

    <div className="contentSide">
      <div className="contentContainer">
        <div className="paddedMaxWidthContainer">
          <div style={{ fontStyle: 'italic', fontSize: '1.3em', fontWeight: 'bold' }}>
            Dine inside a
            <div className="spacedFont" style={{ fontStyle: 'normal', textAlign: 'inherit' }}>
              Dormant <strong>Volcano</strong>
            </div>
          </div>

          <div className="summaryContainer" id="summary">
            <div className="item">
              <img
                src={`${ASSET_PREFIX}/images/iceland-raffle/ticket.svg`}
              />
              Choose your entries
            </div>
            <div className="item">
              <img
                src={`${ASSET_PREFIX}/images/iceland-raffle/trophy.svg`}
              />
              Guaranteed winner drawn
            </div>
            <div className="item">
              <img
                src={`${ASSET_PREFIX}/images/iceland-raffle/cause.svg`}
              />
              Support a great cause
            </div>
          </div>

          <p>
            You and your +1 could win this once-in-a-lifetime experience: a private dinner inside a dormant volcano in Iceland! Spend 6 days in the land of Fire and Ice, absorbing all the magic it has to offer.
          </p>

          <p>
            Stay in the luxury ION Adventure Hotel with epic views over the majestic lava fields, catch some Northern Lights, and let a private jeep take you to the main event inside the iconic Þríhnúkagígur volcano for a 4-course bespoke meal prepared for you by a personal chef.
          </p>

          <p>
            <strong>One guaranteed winner</strong> will win this experience of epic proportions and make memories to last a lifetime, and it might just be you. Why wait? Try your luck today!
          </p>

          <div className='timingSection'>
            <div className='validForContainer'>
              <img
                src={`${ASSET_PREFIX}/images/iceland-raffle/calendar-icon.svg`}
                alt=""
                style={{
                  height: '28px',
                  width: '28px',
                  marginBottom: '1em',
                }}
              />
              Valid for 18 months — win now, travel later.
            </div>
          </div>
        </div>
      </div>
    </div>

    <style jsx>
      {`
        .container {
          width: 100%;
          display: flex;
        }
        
        .image {
          object-fit: cover;
          height: 100%;
          max-height: 800px;
        }
        
        .container>* {
          width: 50%;
        }
        
        .contentSide {
          display: flex;
          align-items: center;
        }
        
        .ctaContainer {
          width: 100%;
          margin: 2em 0;
          text-align: left;
        }
        
        .summaryContainer {
          display: flex;
          border: 3px solid #e1e1e1;
          border-radius: 6px;
          padding: 0.5em 1em;
          margin: 2em 0;
        }
        
        .summaryContainer .item {
          display: flex;
          align-items: center;
          font-weight: 600;
          font-size: 0.9em;
          margin: 0 0.4em;
        }
        
        .summaryContainer img {
          height: 26px;
          margin-right: 0.8em;
        }
        
        .timingSection {
          margin-top: 1em;
          display: flex;
          justify-content: flex-start;
          font-weight: 700;
          width: 100%;
        }
        
        .validForContainer {
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        
        .validForContainer img {
          margin-right: 1em;
        }
        
        @media(max-width: 1000px) {
          .summaryContainer .item {
            font-size: 0.8em;
            margin: 0 0.2em;
          }
        }
        
        .paddedMaxWidthContainer {
          margin: auto;
          align-items: flex-start;
          padding: 75px 2em 40px;
          max-width: 500px;
        }
        
        @media(max-width: 800px) {
          .paddedMaxWidthContainer {
            padding-left: 0.5em;
            padding-right: 0.5em;
          }
          
          .image {
            // Fixes bug on physical iOS device where parent section was filled in image.
            height: auto;
            max-height: 300px;
          }
          
          .container {
            flex-direction: column-reverse;
          }
          
          .container>* {
            width: 100%;
          }
          
          .contentContainer {
            margin: 0 auto;
          }
          
          .ctaContainer {
            text-align: center;
          }
        }
      `}
    </style>
  </div>
);

export default OverviewSection;
